import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./portfolio11.css";

const Portfolio11 = () => {
  const navigate = useNavigate();

  const onButtonContainerClick = useCallback(() => {
    navigate("/portfolio-3");
  }, [navigate]);

  useEffect(() => {
    const scrollAnimElements = document.querySelectorAll(
      "[data-animate-on-scroll]"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            const targetElement = entry.target;
            targetElement.classList.add("animate");
            observer.unobserve(targetElement);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    for (let i = 0; i < scrollAnimElements.length; i++) {
      observer.observe(scrollAnimElements[i]);
    }

    return () => {
      for (let i = 0; i < scrollAnimElements.length; i++) {
        observer.unobserve(scrollAnimElements[i]);
      }
    };
  }, []);
  return (
    <div className="portfolio-11">
      <div className="eclipse" />
      <div className="eclipse1" />
      <img
        className="supertoroid-yellow-glossy-icon"
        alt=""
        src="/supertoroidyellowglossy1@2x.png"
      />
      <div className="ui">
        <div className="button" onClick={onButtonContainerClick}>
          <div className="view-portfolio">View Portfolio</div>
          <img
            className="iconfont-awesome-freesolidl"
            alt=""
            src="/iconfont-awesome-freesolidllongarrowaltright.svg"
          />
        </div>
        <img
          className="saly-13-icon"
          alt=""
          src="/saly13@2x.png"
          data-animate-on-scroll
        />
        <img
          className="supertoroid-purple-glossy-icon"
          alt=""
          src="/supertoroidpurpleglossy1@2x.png"
          data-animate-on-scroll
        />
        <div className="discover-the-artistry-behind-m-wrapper">
          <div className="discover-the-artistry">
            Discover the Artistry Behind My Pixels
          </div>
        </div>
        <div className="hey-there-im-sayan-das-a-mu-wrapper">
          <div className="hey-there-im-container">
            <p className="hey-there-im-sayan-das-a-mu">
              <span className="hey-there-im">{`Hey there, I'm `}</span>
              <span className="sayan-das">Sayan Das</span>
              <span>
                , a multifaceted creative soul with a passion for UI/UX design,
                an insatiable love for gaming.
              </span>
            </p>
            <p className="hey-there-im-sayan-das-a-mu">&nbsp;</p>
            <p className="hey-there-im-sayan-das-a-mu">
              Welcome to my digital haven, where I'll take you on a journey
              through my diverse world of creativity.
            </p>
          </div>
        </div>
      </div>
      <img
        className="roundcube-orange-glossy-icon"
        alt=""
        src="/roundcubeorangeglossy1@2x.png"
      />
      <img
        className="pill-blue-glossy-icon"
        alt=""
        src="/pillblueglossy1@2x.png"
      />
      <img
        className="sphere-white-matte-icon"
        alt=""
        src="/spherewhitematte@2x.png"
      />
    </div>
  );
};

export default Portfolio11;
